import React from 'react';
import Button from "@mui/material/Button";

const UploadFile = (props) => {
  return (
    <div>
      <Button variant="contained" color="secondary" size='medium' component="label"
        onClick={props.onClick}>
        <input
          type="file"
          accept={props.acceptedTypes || 'image/*'}
          hidden
          onChange={props.onFileChange}
        />
        Upload</Button>
      <hr />
    </div>
  )
}

export default UploadFile;
